// extracted by mini-css-extract-plugin
module.exports = {"box":"loading_box_2VJze","container":"loading_container_1rMGt","image":"loading_image_QxsVL","horizon":"loading_horizon_Ut3_2","loading":"loading_loading_3efFy"};